export interface MediaItem {
  id: number;
  title: string;
  tag: string;
  views: string;
  imageUrl: string;
  duration: string;
}

export interface FeatureItem {
  id: number;
  icon: string;
  title: string;
  desc: string;
}

export interface CardItem {
  id: number;
  title: string;
  desc: string;
  tag: string;
  time: string;
  views: string;
  comments: string;
  imageUrl: string;
}

export interface IndexItem {
  id: number;
  title: string;
  count: string;
  tag: string;
}

export interface RankingItem {
  id: number;
  rank: number;
  title: string;
  heat: string;
  trend: 'up' | 'down' | 'new' | 'stable';
  tag: string;
}

export interface UpdateItem {
  id: number;
  time: string;
  title: string;
  desc: string;
  badge?: string;
}

export interface CarouselItem {
  id: number;
  title: string;
  desc: string;
  tag: string;
  imageUrl: string;
}

export interface TopicItem {
  id: number;
  name: string;
  heat: string;
  isHot: boolean;
}

export interface CommentItem {
  id: number;
  avatar: string;
  name: string;
  time: string;
  content: string;
  likes: string;
}

export interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

export const heroStats = [
  { label: '今日新料', value: '1,286 条' },
  { label: '实时在线', value: '38.2 万瓜友' },
  { label: '累计爆料', value: '126 万+ 条' },
];

export const mediaItems: MediaItem[] = [
  {
    id: 1,
    title: '某顶流深夜发文回应恋情传闻，工作室紧急声明引热议',
    tag: '独家直击',
    views: '89.6万',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20illustration%20of%20breaking%20entertainment%20news%20with%20abstract%20spotlight%20on%20a%20stage%2C%20warm%20red%20and%20amber%20tones%2C%20microphone%20silhouette%20in%20foreground%2C%20soft%20bokeh%20background%2C%20modern%20editorial%20style%2C%20high%20contrast%20lighting%2C%20news%20media%20atmosphere&width=600&height=400&seq=media-card-01&orientation=landscape',
    duration: '03:25',
  },
  {
    id: 2,
    title: '综艺录制现场突发状况，嘉宾离场内幕遭知情人士曝光',
    tag: '录制揭秘',
    views: '67.3万',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20moody%20television%20studio%20set%20with%20dramatic%20red%20curtains%20and%20warm%20spotlights%2C%20abstract%20shapes%20representing%20cameras%20and%20equipment%2C%20dark%20atmospheric%20edges%2C%20entertainment%20industry%20vibe%2C%20soft%20glow%20effect%2C%20cinematic%20lighting&width=600&height=400&seq=media-card-02&orientation=landscape',
    duration: '05:12',
  },
  {
    id: 3,
    title: '年度盛典名单泄露？多位大咖确认出席，节目单抢先看',
    tag: '活动前瞻',
    views: '72.8万',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20glamorous%20red%20carpet%20scene%20with%20abstract%20golden%20particles%20floating%2C%20warm%20amber%20lighting%2C%20elegant%20event%20atmosphere%2C%20soft%20focus%20on%20distant%20spotlights%2C%20award%20ceremony%20vibe%2C%20luxurious%20texture%2C%20dark%20sophisticated%20background&width=600&height=400&seq=media-card-03&orientation=landscape',
    duration: '04:38',
  },
];

export const featureItems: FeatureItem[] = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '独家内幕',
    desc: '深耕娱乐圈多年，拥有独家信息渠道，第一时间为你带来最真实的内幕爆料，让你走在吃瓜最前线。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '多方核实',
    desc: '每条爆料均经过多渠道交叉验证，拒绝谣言和假瓜，坚守真实底线，做靠谱的吃瓜群众在线爆料平台。',
  },
  {
    id: 3,
    icon: 'ri-group-line',
    title: '瓜友社区',
    desc: '汇聚数百万吃瓜群众在线讨论，实时交流最新爆料信息，一起分析、一起推理，吃瓜体验翻倍。',
  },
];

export const cardItems: CardItem[] = [
  {
    id: 1,
    title: '某85花离婚协议细节曝光，财产分割暗藏玄机，圈内人透露更多猛料',
    desc: '据知情人透露，双方早在半年前就已分居，离婚协议中涉及的财产分配引发广泛关注，其中几处关键条款被指暗藏猫腻。',
    tag: '明星婚姻',
    time: '2小时前',
    views: '32.6万',
    comments: '1.2万',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20split%20composition%20of%20two%20abstract%20figures%20moving%20apart%20with%20golden%20and%20crimson%20particles%20between%20them%2C%20warm%20ambient%20lighting%2C%20emotional%20atmosphere%2C%20soft%20focus%2C%20editorial%20style%2C%20dark%20sophisticated%20background%2C%20entertainment%20news%20visual&width=800&height=600&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '新生代顶流合约到期去向成谜，多家经纪公司暗中角力',
    desc: '合约即将到期的消息引发行业震动，据传已有三家头部经纪公司开出天价签约条件，而其本人尚未表态最终去向。',
    tag: '艺人动态',
    time: '4小时前',
    views: '28.1万',
    comments: '9,837',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20abstract%20illustration%20of%20a%20rising%20star%20with%20multiple%20converging%20spotlights%20from%20different%20directions%2C%20warm%20golden%20and%20red%20beams%2C%20dramatic%20stage%20setting%2C%20high%20contrast%2C%20modern%20entertainment%20industry%20aesthetic%2C%20mysterious%20atmosphere&width=800&height=600&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '热播剧背后资本博弈真相，换角风波内幕比剧情更精彩',
    desc: '从最初的选角到最终的播出，这部热播剧经历了数次重大调整，背后的资本博弈和利益权衡，足以拍一部新的职场剧。',
    tag: '影视内幕',
    time: '6小时前',
    views: '25.3万',
    comments: '8,104',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20film%20set%20scene%20with%20overlapping%20abstract%20shapes%20representing%20hidden%20business%20deals%2C%20warm%20crimson%20and%20amber%20lighting%2C%20director%20chair%20silhouette%2C%20cinematic%20atmosphere%2C%20dark%20moody%20edges%2C%20entertainment%20industry%20intrigue%20visual&width=800&height=600&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '音乐节后台真实关系曝光，那些台上的"好兄弟"台下竟是如此',
    desc: '某大型音乐节后台发生的真实一幕被现场工作人员记录下来，几位歌手之间的互动与台前表现形成强烈反差，令人唏嘘。',
    tag: '音乐圈',
    time: '8小时前',
    views: '21.7万',
    comments: '6,952',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20backstage%20music%20festival%20scene%20with%20abstract%20colored%20lights%20and%20silhouettes%2C%20warm%20amber%20stage%20glow%20contrasting%20with%20dark%20backstage%20area%2C%20musical%20equipment%20shapes%2C%20dramatic%20atmosphere%2C%20cinematic%20lighting%2C%20entertainment%20news%20visual&width=800&height=600&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '综艺常驻嘉宾被连夜换掉，节目组内部邮件流出引爆舆论',
    desc: '一份据称来自节目组内部的邮件显示，某常驻嘉宾因不当言论被连夜替换，替补人选已在凌晨紧急敲定，录制计划被迫延期。',
    tag: '综艺风波',
    time: '10小时前',
    views: '19.4万',
    comments: '5,831',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20abstract%20television%20studio%20with%20a%20sudden%20dramatic%20shift%2C%20one%20chair%20being%20replaced%20by%20another%20in%20visual%20metaphor%2C%20warm%20red%20and%20amber%20studio%20lights%2C%20dark%20moody%20atmosphere%2C%20cinematic%20style%2C%20entertainment%20news%20intrigue&width=800&height=600&seq=card-05&orientation=landscape',
  },
];

export const indexItems: IndexItem[] = [
  { id: 1, title: '明星婚姻', count: '326篇', tag: 'hot' },
  { id: 2, title: '艺人合约', count: '218篇', tag: 'new' },
  { id: 3, title: '影视内幕', count: '193篇', tag: 'hot' },
  { id: 4, title: '综艺风波', count: '167篇', tag: '' },
  { id: 5, title: '音乐圈', count: '142篇', tag: '' },
  { id: 6, title: '时尚八卦', count: '128篇', tag: 'new' },
  { id: 7, title: '体育娱乐', count: '105篇', tag: '' },
  { id: 8, title: '直播爆料', count: '98篇', tag: '' },
  { id: 9, title: '海外吃瓜', count: '87篇', tag: '' },
];

export const rankingItems: RankingItem[] = [
  { id: 1, rank: 1, title: '某85花离婚协议细节曝光引全网震动', heat: '986万', trend: 'up', tag: '爆' },
  { id: 2, rank: 2, title: '新生代顶流合约到期去向引发多方争夺', heat: '872万', trend: 'up', tag: '热' },
  { id: 3, rank: 3, title: '热播剧资本博弈内幕远比剧情更震撼', heat: '765万', trend: 'new', tag: '新' },
  { id: 4, rank: 4, title: '综艺常驻嘉宾被连夜替换的内部真相', heat: '698万', trend: 'up', tag: '热' },
  { id: 5, rank: 5, title: '某顶流深夜发文后工作室紧急公关', heat: '621万', trend: 'down', tag: '' },
  { id: 6, rank: 6, title: '年度盛典名单泄露多位大咖确认出席', heat: '554万', trend: 'new', tag: '新' },
  { id: 7, rank: 7, title: '音乐节后台真实关系曝光反差巨大', heat: '487万', trend: 'stable', tag: '' },
];

export const updateItems: UpdateItem[] = [
  {
    id: 1,
    time: '14:32',
    title: '某女星孕期仍在拍戏，敬业精神获业内导演力赞',
    desc: '据剧组工作人员透露，该女星在拍摄期间从未因身体原因耽误进度，所有高难度镜头均亲自完成，其专业态度令全组动容。',
    badge: '最新',
  },
  {
    id: 2,
    time: '13:15',
    title: '知名编剧公开炮轰某流量演员耍大牌',
    desc: '该编剧在社交平台连发三条动态，直指某合作过的流量演员在片场频繁迟到、不背台词，引发网友热烈讨论。',
    badge: '热议',
  },
  {
    id: 3,
    time: '11:48',
    title: '某组合内部不和传闻再度升级，成员互取关',
    desc: '有粉丝发现组合内两名成员已互相取消社交平台关注，此前关于团队内部矛盾的传闻再次被推上风口浪尖。',
    badge: '',
  },
  {
    id: 4,
    time: '10:20',
    title: '三大平台争抢某热门IP改编权，竞标价突破记录',
    desc: '据悉三家主流视频平台均派出核心团队参与竞标，目前出价已超过此前所有IP改编权的成交记录，决策结果最快下周揭晓。',
    badge: '',
  },
  {
    id: 5,
    time: '09:05',
    title: '某老牌歌手宣布复出巡演，门票预售秒罄',
    desc: '时隔八年重返舞台的消息一经公布便引发抢票热潮，首轮预售的三场演出门票在三分钟内全部售罄，主办方正在加开场次。',
    badge: '',
  },
  {
    id: 6,
    time: '08:12',
    title: '昨晚综艺录制现场灯光事故，所幸无人受伤',
    desc: '录制过程中一组灯光设备意外脱落，节目组紧急暂停录制并疏散观众，事故原因正在调查中，预计下周恢复录制。',
    badge: '',
  },
  {
    id: 7,
    time: '昨日 23:45',
    title: '知情人士爆料某颁奖礼暗箱操作，获奖名单提前锁定',
    desc: '距离颁奖礼还有一周，一位自称业内人士的账号发布长文，详细披露了评奖过程中的暗箱操作细节，主办方暂未回应。',
    badge: '',
  },
];

export const carouselItems: CarouselItem[] = [
  {
    id: 1,
    title: '深度揭秘：娱乐圈"资源置换"的隐秘生态',
    desc: '从角色分配到综艺名额，从品牌代言到时尚资源，娱乐圈内部存在着一条不为人知的资源置换链条。我们历时三个月走访数十位圈内人士，为你揭开这个隐秘生态的真实面纱。',
    tag: '深度调查',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20abstract%20network%20of%20interconnected%20nodes%20and%20lines%20representing%20hidden%20connections%20in%20entertainment%20industry%2C%20warm%20crimson%20and%20amber%20glowing%20points%2C%20dark%20sophisticated%20background%2C%20investigative%20journalism%20visual%2C%20modern%20editorial%20design%2C%20high%20contrast&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '追踪报道：那些"塌房"艺人如今身在何处',
    desc: '曾经风光无限的他们，在经历了舆论风暴后选择了不同的人生道路。有人沉寂退圈、有人转型幕后、也有人默默复出。我们追踪了十位代表性人物，记录下他们的现状。',
    tag: '追踪报道',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20visual%20of%20fading%20spotlights%20and%20disappearing%20stage%2C%20transitioning%20from%20bright%20to%20dim%2C%20warm%20amber%20fading%20to%20dark%2C%20symbolic%20of%20fallen%20fame%2C%20cinematic%20moody%20atmosphere%2C%20editorial%20style%2C%20dramatic%20lighting&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '数据观察：2025上半年吃瓜热度趋势解读',
    desc: '从明星婚变到综艺争议，从影视内幕到音乐圈八卦，我们用数据为你梳理今年上半年的吃瓜热点分布、话题热度变化以及瓜友关注趋势。哪类爆料最受关注？哪个时间段瓜最多？答案都在这里。',
    tag: '数据分析',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20with%20warm%20red%20and%20amber%20charts%20and%20graphs%2C%20rising%20trend%20lines%2C%20modern%20infographic%20aesthetic%2C%20dark%20sophisticated%20background%2C%20entertainment%20analytics%20theme%2C%20soft%20glowing%20data%20points%2C%20clean%20editorial%20design&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '圈内人说：一个娱乐记者的十年吃瓜手记',
    desc: '从业十年，他见证了娱乐圈的起起落落，亲历了无数爆料的诞生与反转。在这篇长文中，他将分享那些从未公开过的幕后故事、行业潜规则以及作为见证者的真实感悟。',
    tag: '人物特写',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20vintage%20journalist%20notebook%20and%20camera%20on%20a%20wooden%20desk%20illuminated%20by%20warm%20desk%20lamp%2C%20old%20press%20passes%20and%20clippings%20scattered%2C%20crimson%20and%20amber%20warm%20lighting%2C%20nostalgic%20yet%20modern%20editorial%20photography%2C%20dark%20background%2C%20storytelling%20atmosphere&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
];

export const topicItems: TopicItem[] = [
  { id: 1, name: '#某85花离婚细节曝光#', heat: '986万', isHot: true },
  { id: 2, name: '#顶流合约到期#', heat: '872万', isHot: true },
  { id: 3, name: '#热播剧资本博弈#', heat: '765万', isHot: true },
  { id: 4, name: '#综艺嘉宾被换#', heat: '698万', isHot: true },
  { id: 5, name: '#年度盛典名单#', heat: '554万', isHot: true },
  { id: 6, name: '#音乐节后台真相#', heat: '487万', isHot: false },
  { id: 7, name: '#女星孕期拍戏#', heat: '423万', isHot: false },
  { id: 8, name: '#编剧炮轰流量演员#', heat: '389万', isHot: false },
  { id: 9, name: '#歌手复出巡演#', heat: '351万', isHot: false },
  { id: 10, name: '#颁奖礼暗箱操作#', heat: '298万', isHot: false },
  { id: 11, name: '#组合成员互取关#', heat: '265万', isHot: false },
];

export const commentItems: CommentItem[] = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20user%20avatar%20with%20warm%20crimson%20gradient%20circle%20on%20light%20background%2C%20clean%20design%2C%20modern%20social%20media%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '1小时前',
    content: '这个瓜也太大了！看完整个爆料时间线，感觉比电视剧还精彩。圈内的事真是让人大开眼界，坐等后续发展。',
    likes: '2,836',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20user%20avatar%20with%20warm%20amber%20gradient%20circle%20on%20light%20background%2C%20clean%20design%2C%20modern%20social%20media%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '娱乐圈观察员',
    time: '3小时前',
    content: '关注吃瓜群三年了，这里的爆料确实比别处靠谱。多方核实这一点很让人放心，不传谣不信谣，做有底线的吃瓜群众。',
    likes: '1,952',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20user%20avatar%20with%20warm%20terracotta%20gradient%20circle%20on%20light%20background%2C%20clean%20design%2C%20modern%20social%20media%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '深夜吃瓜人',
    time: '5小时前',
    content: '每天晚上睡前必刷一圈吃瓜群，已经成为习惯了。今天的更新量很大，信息密度高，看完需要消化一会儿，信息量爆炸。',
    likes: '1,538',
  },
];

export const faqItems: FaqItem[] = [
  {
    id: 1,
    question: '吃瓜群的爆料信息可靠吗？',
    answer: '吃瓜群坚持"多方核实"原则，每条爆料在发布前均经过多渠道交叉验证。我们拥有深耕娱乐圈多年的信息网络，拒绝发布未经证实的传闻和谣言，致力于做靠谱的吃瓜群众在线爆料平台。但娱乐圈信息瞬息万变，如有更新我们会第一时间跟进。',
  },
  {
    id: 2,
    question: '如何第一时间获取最新爆料？',
    answer: '你可以收藏本页面，或关注"最新快讯"板块，我们会实时更新各类爆料动态。同时建议每天早晚各刷一次"吃瓜热度榜"，热门内容一目了然。移动端体验也已优化，随时随地在线吃瓜更方便。',
  },
  {
    id: 3,
    question: '可以向吃瓜群投稿爆料吗？',
    answer: '当然可以。我们非常欢迎各路瓜友通过"投稿爆料"板块提供线索和素材。请确保所提供的信息真实可靠并附上可查证来源，我们的编辑团队会尽快审核处理。优质爆料一经采纳将注明供稿人信息（可选择匿名）。',
  },
  {
    id: 4,
    question: '吃瓜群和一般娱乐新闻有什么不同？',
    answer: '与主流娱乐新闻不同，吃瓜群更侧重于幕后故事、行业内部揭秘和深度分析。我们不仅报道"发生了什么"，更关注"为什么发生"以及"背后有什么"。这里汇聚了大量懂行瓜友的精彩分析和讨论，让吃瓜不止于表面信息。',
  },
];